
<span>
  <i :class="classes" />
  <span
    v-show="spin || pulse"
    class="sr-only"
    v-text="animationFallBack"
  />
</span>
